import React, { useState, useEffect } from "react";
import { DateRangePicker } from "rsuite";
import { getAudioList, deleteAudio } from "./_redux/monitorCrud";
import { subDays } from "date-fns";
import "rsuite/dist/rsuite.min.css";
import { Tooltip, Checkbox } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import playIconSVG from "../../../icons/playIcon.svg";
import CalendarIcon from "../../../icons/calendar.svg";
import Moment from "moment";
import Pagination from "@material-ui/lab/Pagination";
import AudioPlayPopup from "./pages/AudioPlayPopup";
import { AudioRecordsperPage } from "../../../Application_Constants";
import DeletePage from "./pages/DeletePage";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as Actions from "../redux/action";
import { DeletePopupMsg } from "../../../Application_Constants";
/* eslint-disable react-hooks/exhaustive-deps */
const { afterToday } = DateRangePicker;

const NewDateRange = React.forwardRef((props, ref) => {
  const [date, setDate] = useState([subDays(new Date(), 6), new Date()]);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [state, setState] = useState({
    audioList: [],
    loading: true,
    errorMessage: false,
    totalCount: 0,
    paginationLoading: false,
    currentPage: 1,
    playID: [],
    modalShow: false,
    isPlay: false,
    hasToCheckAll: false,
    checkedArray: [],
    skipedArray: [],
    refreshaudioList: [],
    deleteMsg: DeletePopupMsg.emptyMsg,
    toshowokbtn: true,
    refresh: true,
    errorMsg: false,
  });

  // for new audio uplaoded grid will refresh
  useEffect(() => {
    if (props.isaudioGrid === true) {
      refreshGridOnPageChange();
    }
  }, [props.isaudioGrid]);
  useEffect(() => {
    audioListGrid();
  }, [state.currentPage]);

  useEffect(() => {
    if (props.isRefreshAudio === true) {
      audioListGrid();
    }
  }, [props.isRefreshAudio]);

  // call after page change and state of audiolist changes
  useEffect(() => {
    pageChangeCBSelect();
  }, [state.audioList]);

  // call when user click on delete button
  useEffect(() => {
    if (props.isDelete === true) {
      setDeleteModalShow(true);
      props.handleDelete(false);
      initializeDeletePopup();
    }
  }, [props.isDelete]);

  const deletemodalClose = (opt) => {
    if (opt === "cancel" || opt === "ok") {
      setDeleteModalShow(false);
      state.errorMsg = false;
    } else if (opt === "continue") {
      deleteAudiofunc();
    }
  };

  const deleteAudiofunc = () => {
    setRemoveLoading(true);
    deleteAudio(
      date[0],
      date[1],
      props.monitor.id,
      state.checkedArray,
      state.skipedArray
    )
      .then((res) => {
        if (res.data.status) {
          resetValues();
          setState({
            ...state,
            errorMsg: false,
          });
          setRemoveLoading(false);
          setDeleteModalShow(false);
        } else {
          setRemoveLoading(false);
          setState({
            ...state,
            errorMsg: res.data.message,
          });
        }
      })
      .catch((error) => {
        setRemoveLoading(false);
        if (error.response) {
          if (error.response.status !== 404 && error) {
            setState({
              ...state,
              errorMsg: error.response.data.message,
            });
          } else {
            setState({
              ...state,
              errorMsg: error.message,
            });
          }
        } else {
          setState({
            ...state,
            errorMsg: error.message,
          });
        }
      });
  };

  const resetValues = () => {
    setPartiallySelected(false);
    setIsAllSelected(false);
    state.skipedArray = [];
    state.checkedArray = [];
    state.hasToCheckAll = false;
    state.deleteMsg = DeletePopupMsg.emptyMsg;
    state.toshowokbtn = true;
    refreshGridOnPageChange();
    state.currentPage = 1;
  };
  const playAudio = (audioID) => {
    setState({
      ...state,
      playID: audioID,
      modalShow: true,
      isPlay: true,
    });
  };
  const modalClose = () => {
    setState({
      ...state,
      modalShow: false,
      isPlay: false,
    });
  };

  const handlePageChange = (event, value) => {
    let pageValue = value;
    setState({
      ...state,
      currentPage: pageValue,
    });
  };
  const pageChangeCBSelect = () => {
    if (isAllSelected) {
      state.audioList.forEach((item) => {
        if (state.skipedArray.includes(item.correlation_id)) {
          item.checked = false;
        } else {
          item.checked = isAllSelected;
        }
      });
    } else {
      state.audioList.forEach((item) => {
        if (state.checkedArray.includes(item.correlation_id)) {
          item.checked = true;
        }
      });
    }
    setState({
      ...state,
      refreshaudioList: state.audioList,
    });
  };
  const audioListGrid = () => {
    if (state.currentPage !== 0) {
      setState({ ...state, loading: true, audioList: [] });
    }
    if (props.monitor !== null) {
      getAudioList(
        props.monitor.id,
        date[0],
        date[1],
        AudioRecordsperPage,
        state.currentPage
      )
        .then((res) => {
          const { data, status, message, count } = res.data;
          if (status) {
            setState({
              ...state,
              audioList: data,
              loading: false,
              errorMessage: false,
              totalCount: count,
            });
          } else {
            setState({
              ...state,
              errorMessage: message,
              loading: false,
              paginationLoading: false,
              totalCount: 0,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status !== 404 && error) {
              setState({
                ...state,
                audioList: [],
                errorMessage: error.response.data.message,
                loading: false,
                paginationLoading: false,
                totalCount: 0,
              });
            } else {
              this.props.history.push("error/error-v1");
            }
          } else {
            setState({
              ...state,
              audioList: [],
              errorMessage: error.message,
              loading: false,
              paginationLoading: false,
              totalCount: 0,
            });
          }
        });
    }
    props.handleAudioGrid(false);
    props.refreshAudio(false);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      boxShadow: theme.shadows[1],
      fontSize: 11,
      padding: "8px",
      fontFamily: "Noto Sans Display",
    },
  }))(Tooltip);

  const refreshGridOnPageChange = () => {
    if (state.currentPage !== 1) {
      setState({
        ...state,
        currentPage: 1,
      });
    } else {
      audioListGrid();
    }
  };

  const totalPages = Math.ceil(state.totalCount / AudioRecordsperPage);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [partiallySelected, setPartiallySelected] = useState(false);
  const [, setcheckedItem] = useState([]);

  const selectAll = () => {
    setPartiallySelected(false);
    const hasToCheckAll = !state.hasToCheckAll;
    currentaudioList.map((item) => {
      item.checked = hasToCheckAll;
      return item;
    });
    setIsAllSelected(!isAllSelected);
    setState({
      ...state,
      checkedArray: [],
      skipedArray: [],
      hasToCheckAll: hasToCheckAll,
    });
  };

  const handleSingleSelect = (clickedItem) => {
    clickedItem.checked = !clickedItem.checked;
    setcheckedItem(clickedItem);

    if (isAllSelected) {
      if (clickedItem.checked === true) {
        const skipedArrayindex = state.skipedArray.indexOf(
          clickedItem.correlation_id
        );
        if (skipedArrayindex > -1) {
          // only splice array when item is found
          state.skipedArray.splice(skipedArrayindex, 1); // 2nd parameter means remove one item only
        }
        //toCheckAllBox(state.checkedArray, state.skipedArray);
      } else {
        state.skipedArray.push(clickedItem.correlation_id);
        //toCheckAllBox(state.checkedArray, state.skipedArray);
      }
    } else {
      if (clickedItem.checked === true) {
        setPartiallySelected(true);
        state.checkedArray.push(clickedItem.correlation_id);
        //toCheckAllBox(state.checkedArray, state.skipedArray);
      } else {
        const checkedArrayindex = state.checkedArray.indexOf(
          clickedItem.correlation_id
        );
        if (checkedArrayindex > -1) {
          // only splice array when item is found
          state.checkedArray.splice(checkedArrayindex, 1); // 2nd parameter means remove one item only
        }
        //toCheckAllBox(state.checkedArray, state.skipedArray);
      }
    }
    toCheckAllBox();
  };

  const toCheckAllBox = () => {
    if (state.totalCount === state.checkedArray.length.toString()) {
      setPartiallySelected(false);
      setIsAllSelected(true);
      setState({
        ...state,
        checkedArray: [],
        skipedArray: [],
        hasToCheckAll: true,
      });
    } else if (state.totalCount === state.skipedArray.length.toString()) {
      setPartiallySelected(false);
      setIsAllSelected(false);
      setState({
        ...state,
        checkedArray: [],
        skipedArray: [],
        hasToCheckAll: false,
      });
    } else if (
      state.skipedArray.length === 0 &&
      state.checkedArray.length === 0
    ) {
      setPartiallySelected(false);
      setIsAllSelected(isAllSelected);
    } else {
      setPartiallySelected(true);
    }
  };

  const initializeDeletePopup = () => {
    if (isAllSelected || state.checkedArray.length > 0) {
      setState({
        ...state,
        deleteMsg: DeletePopupMsg.deleteRecord,
        toshowokbtn: false,
      });
    } else {
      setState({
        ...state,
        deleteMsg: DeletePopupMsg.emptyMsg,
        toshowokbtn: true,
      });
    }
  };
  // to bind with html created new array
  const currentaudioList = state.refreshaudioList;

  return (
    <>
      <div className="row">
        <div className="col-md-12 dateRangePicker bor">
          <label>
            <img
              src={CalendarIcon}
              alt="CalendarIcon"
              className="calendar"
            ></img>
            <DateRangePicker
              value={date}
              onChange={setDate}
              onExit={() => {
                refreshGridOnPageChange();
              }}
              showOneCalendar
              cleanable={false}
              appearance="subtle"
              disabledDate={afterToday()}
              placeholder="Select a date or date range"
              character=" to "
              format="MM-dd-yyyy"
            />
          </label>
        </div>
      </div>
      <div className="row" style={{ margin: "0px" }}>
        <div
          className="col-md-12 table-responsive tableFixHeadAudio font_family  "
          style={{ padding: "0px" }}
        >
          <table
            className="table table-hover table-striped table-hover align-middle audioListGrid"
            style={{ marginBottom: "0" }}
            id="monitorScroll"
          >
            <thead>
              <tr>
                <th style={{ width: "10px" }} scope="col">
                  <Checkbox
                    disabled={state.totalCount === 0}
                    checked={isAllSelected}
                    indeterminate={partiallySelected}
                    onChange={(e) => selectAll()}
                  ></Checkbox>
                </th>
                <th style={{ width: "70px" }}></th>
                <th className="text">Monitor Name</th>
                <th className="text">Code Name</th>
                <th className="text">Channel </th>

                <th className="text">Date / Time</th>
              </tr>
            </thead>
            <tbody>
              {state.loading ? (
                <tr>
                  <td colSpan="12" align="center">
                    <div class="d-flex justify-content-center">
                      <span
                        style={{ justifyContent: "center" }}
                        className="ml-3 spinner spinner-dark "
                      ></span>
                    </div>
                  </td>
                </tr>
              ) : (
                currentaudioList &&
                currentaudioList.map((value, index) => (
                  <tr key={index.toString()}>
                    <td style={{ width: "10px" }}>
                      <Checkbox
                        checked={value.checked}
                        onChange={(e) => handleSingleSelect(value)}
                      ></Checkbox>
                    </td>
                    <td onClick={(e) => playAudio(value)}>
                      <img
                        style={{
                          marginTop: "15px",
                          marginBottom: "12px",
                          marginRight: "13px",
                          cursor: "pointer",
                        }}
                        src={playIconSVG}
                        alt="playIconSVG"
                      ></img>
                    </td>
                    <td>
                      <LightTooltip
                        PopperProps={{ style: { marginTop: "-20px" } }}
                        title=<span style={{ fontSize: "12px" }}>
                          {value.monitor_id}
                        </span>
                      >
                        <p>{value.monitor_id}</p>
                      </LightTooltip>
                    </td>
                    <td>
                      <p>{value.code_name}</p>
                    </td>
                    <td>
                      <p>{value.channel}</p>
                    </td>

                    <td>
                      <p>
                        {Moment(value.created_date).format(
                          "MM-DD-yyyy, HH:mm:ss"
                        )}
                      </p>
                    </td>
                  </tr>
                ))
              )}

              {state.errorMessage &&
              !state.loading &&
              state.audioList.length === 0 ? (
                <tr>
                  <td colSpan="12" align="center">
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      {state.errorMessage}
                    </p>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        {state.isPlay ? (
          <AudioPlayPopup
            id="modal"
            file={state.playID}
            show={state.modalShow}
            audioData={props.monitor}
            onHide={(value) => modalClose(value)}
          ></AudioPlayPopup>
        ) : null}
      </div>
      {state.totalCount > AudioRecordsperPage ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            marginLeft: "6px",
            marginRight: "6px",
            marginTop: "20px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {state.loading
            ? Array.from({ length: 1 }, (_, index) => (
                <Pagination
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                  }}
                  onChange={handlePageChange}
                  count={totalPages}
                  siblingCount={0}
                  boundaryCount={1}
                  disabled
                  page={state.currentPage}
                  color="teal"
                  key={index + 1}
                  className={`pagination-button ${
                    state.currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </Pagination>
              ))
            : Array.from({ length: 1 }, (_, index) => (
                <Pagination
                  style={{
                    display: "flex",
                    flexWrap: "nowrap",
                  }}
                  onChange={handlePageChange}
                  count={totalPages}
                  siblingCount={0}
                  boundaryCount={1}
                  page={state.currentPage}
                  color="teal"
                  key={index + 1}
                  className={`pagination-button ${
                    state.currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  {index + 1}
                </Pagination>
              ))}
        </div>
      ) : null}
      <DeletePage
        show={deleteModalShow}
        headertxt={"Delete Audio"}
        deleteMsg={state.deleteMsg}
        toshowokbtn={state.toshowokbtn}
        haserror={state.errorMsg}
        loading={removeLoading}
        onHide={deletemodalClose}
      ></DeletePage>
    </>
  );
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleDelete: Actions.handleDelete,
      handleAudioGrid: Actions.handleAudioGrid,
      refreshAudio: Actions.refreshAudio,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    isDelete: state.isDelete,
    isaudioGrid: state.isaudioGrid,
    isRefreshAudio: state.isRefreshAudio,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDateRange);
